import React, { useState } from 'react';
import { Box, Grid, TextField, Button, Typography, Container, Paper } from '@mui/material';

const ContactUs: React.FC = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        message: '',
    });

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    return (
        <Box sx={{ 
            minHeight: '100vh', 
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '2rem 0',
        }}>
            <Container maxWidth="md">
                <Paper elevation={3} sx={{ padding: '2rem', borderRadius: '12px', backgroundColor: 'rgba(255, 255, 255, 0.9)' }}>
                    <Typography variant="h4" sx={{ textAlign: 'center', marginBottom: '1.5rem' }}>
                        Get a Quote
                    </Typography>
                    <form action="/process_form.php" method="POST">


                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    label="Name"
                                    name="name"
                                    variant="outlined"
                                    value={formData.name}
                                    onChange={handleChange}
                                    required
                                    sx={{ marginBottom: '1rem' }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    label="Email"
                                    name="email"
                                    variant="outlined"
                                    type="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                    sx={{ marginBottom: '1rem' }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    label="Phone"
                                    name="phone"
                                    variant="outlined"
                                    value={formData.phone}
                                    onChange={handleChange}
                                    required
                                    sx={{ marginBottom: '1rem' }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    label="Message"
                                    name="message"
                                    variant="outlined"
                                    multiline
                                    rows={4}
                                    value={formData.message}
                                    onChange={handleChange}
                                    required
                                    sx={{ marginBottom: '1rem' }}
                                />
                            </Grid>
                            <Grid item xs={12} sx={{ textAlign: 'center' }}>
                                <Button type="submit" variant="contained" color="primary" sx={{ padding: '0.75rem 2rem' }}>
                                    Submit
                                </Button>
                            </Grid>
                        </Grid>
                    </form>
                </Paper>
            </Container>
        </Box>
    );
};

export default ContactUs;
